var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ios-switch",class:{
    'ios-switch--on': _vm.isOn,
    'ios-switch--disabled': _vm.disabled,
  },style:({
    '--active-color': _vm.activeColor,
  }),attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.toggle}},[_c('span',{staticClass:"ios-switch__thumb"})])
}
var staticRenderFns = []

export { render, staticRenderFns }